import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  color?: 'white' | 'gray';
}
export const Card = ({
  children,
  className = '',
  hover = false,
  color = 'white'
}: CardProps) => {
  const bgColor = color === 'white' ? 'bg-white' : 'bg-gray-50';
  const hoverEffect = hover ? 'hover:shadow-lg transition-all duration-200' : '';
  return <div className={`${bgColor} rounded-xl p-6 shadow-sm ${hoverEffect} ${className}`} data-id="element-151">
      {children}
    </div>;
};